import {
  ActivityRegisterAddressData,
  ActivityRegisterDeviceData,
  ActivityRegisterFlowData,
  ActivityRegisterOffersData,
  ActivityRegisterServicesRequestData,
  ActivityRegisterState,
} from '@core/models/swagger/activityRegistry';
import { createAction, props } from '@ngrx/store';

export enum ActivityRegistryActions {
  UpdateDeviceInformation = '[Activity Registry] Update Device Information',
  UpdateServiceInformation = '[Activity Registry] Update Service Information',
  UpdateOffersInformation = '[Activity Registry] Update Offers Information',
  UpdateAddressInformation = '[Activity Registry] Update Address Information',
  UpdateStepInformation = '[Activity Registry] Update Step Information',
  UpdateSessionId = '[Activity Registry] Update Session Id',
  ResetActivityRegistry = '[Activity Registry] Reset Activity Registry',
  UpdateIsModalOpen = '[Activity Registry] Update Is Modal Open',
}

export const UpdateDeviceInformation = createAction(
  ActivityRegistryActions.UpdateDeviceInformation,
  props<{ data: ActivityRegisterDeviceData }>()
);
export const UpdateServiceInformation = createAction(
  ActivityRegistryActions.UpdateServiceInformation,
  props<{ data: ActivityRegisterServicesRequestData }>()
);
export const UpdateOffersInformation = createAction(
  ActivityRegistryActions.UpdateOffersInformation,
  props<{ data: ActivityRegisterOffersData }>()
);
export const UpdateAddressInformation = createAction(
  ActivityRegistryActions.UpdateAddressInformation,
  props<{ data: Partial<ActivityRegisterAddressData['addressInfo']> }>()
);
export const UpdateStepInformation = createAction(
  ActivityRegistryActions.UpdateStepInformation,
  props<{
    data: ActivityRegisterState['step'] & ActivityRegisterFlowData['flowInfo'];
  }>()
);
export const UpdateSessionId = createAction(
  ActivityRegistryActions.UpdateSessionId,
  props<{
    data: string;
  }>()
);
export const UpdateIsModalOpen = createAction(
  ActivityRegistryActions.UpdateIsModalOpen,
  props<{
    data: ActivityRegisterFlowData['flowInfo']['isModalOpen'];
  }>()
);
export const ResetActivityRegistry = createAction(
  ActivityRegistryActions.ResetActivityRegistry,
  props<{
    data: string;
  }>()
);
